module.exports = __webpack_public_path__ + "static/media/011.2fbd83da.jpg";